import React from "react";
import PanelNav from "../Components/Panel/PanelNav";
import Withrowpage from "../Components/Panel/Withrowpage";
import Layout from "./Layout";

export default function Panel() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 grid grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 w-full my-6">
        <PanelNav />
        <Withrowpage />
      </section>
    </Layout>
  );
}
